import { useEffect } from 'react';
import { MAX_PAGE_ID, MIN_PAGE_ID } from '@/shared/constants/constants';

const INTERACTIVE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export function usePageKeyboard({
  onNavigate,
  currentPageNumber,
  step = 1,
  lowerBound = MIN_PAGE_ID,
  upperBound = MAX_PAGE_ID,
}: {
  onNavigate: (page: string, direction: 'left' | 'right') => void;
  currentPageNumber: number;
  step?: number;
  lowerBound?: number;
  upperBound?: number;
}) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (
        e.target instanceof HTMLElement &&
        INTERACTIVE_TAGS.has(e.target.tagName)
      )
        return;

      // RTL: ArrowLeft = forward (higher page), ArrowRight = backward (lower page)
      if (e.key === 'ArrowLeft' && currentPageNumber + step <= upperBound) {
        e.preventDefault();
        onNavigate(String(currentPageNumber + step), 'right');
      }

      if (e.key === 'ArrowRight' && currentPageNumber - step >= lowerBound) {
        e.preventDefault();
        onNavigate(String(currentPageNumber - step), 'left');
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onNavigate, currentPageNumber, step, lowerBound, upperBound]);
}
